import React, { useState, useContext, useEffect, Suspense } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import { useScreenTransition } from '../Hooks/useScreenTransition';
import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';

import './Documents.css';
import './UseCases.css';
import UseCases from './HomePage/UseCases';


const UseCasesPage = ({ windowSize }) => {

  const certifiedUseCasesData = [
    {
      title: "Immigration USCIS Acceptance",
      image: require('../assets/torch.png'),
    },
    {
      title: "Government Official Uses",
      image: require('../assets/government.png'),
    },
    {
      title: "Academic University Admissions",
      image: require('../assets/hat.png'),
    },
    {
      title: "Financial Mortgage Processing",
      image: require('../assets/mortgage.png'),
    },
    {
      title: "Legal Court Cases",
      image: require('../assets/legal.png'),
    },
    {
      title: "Medical Health History",
      image: require('../assets/estet.png'),
    },
  ];

  const standardUseCasesData = [
    {
      title: "Legal Documents",
      image: require('../assets/contracts.png'),
    },
    {
      title: "Business Digital Content",
      image: require('../assets/digital.png'),
    },
    {
      title: "Business Communications",
      image: require('../assets/communications.png'),
    },
    {
      title: "Business Documents",
      image: require('../assets/documentsUseCase.png'),
    },
  ];
  
   

  const { setColor, webP } = useContext(TransitionContext);

  useEffect(() => {
    setColor(false);
  }, [setColor]);

  const { transitionTo } = useScreenTransition();

  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  return (
     <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        <div className='bannerContainer px-2'>
            <h1 className='bannerText text-center'>Use Cases for eVerbary</h1>
        </div>
        <div className='flex flex-col gap-4 w-full items-center pb-[107px] max-md:pb-[30px] px-2'>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>
          While the use cases for our <span className="hoveringTextLink" onClick={(e) => transitionTo('/certified',e)}>certified</span> and <span className="hoveringTextLink" onClick={(e) => transitionTo('/standard',e)}>standard</span> translation services are endless, there are some common use cases that we see daily, which we’ve detailed below to add a bit of additional information that you might find helpful as you navigate the translation process.
            <br/><br/>
            If you have questions about your specific use case, please <span className="hoveringTextLink" onClick={(e) => transitionTo('/contact',e)}>contact us</span>, and we’ll assist in any way we can.
          </p>
         
        </div>
      </div>

      <Suspense fallback={<div></div>}>
        <UseCases windowSize={windowSize} pt="pt-5" />
      </Suspense>
      <Suspense fallback={<div></div>}>
        <UseCases windowSize={windowSize} useCasesData={certifiedUseCasesData} pt="pt-5" title="Certified Translation Use Cases" description="While the use cases for our certified translation services are endless, there are some common use cases that we see daily." />
      </Suspense>
      <Suspense fallback={<div></div>}>
        <UseCases windowSize={windowSize} useCasesData={standardUseCasesData} pt="pt-5" title="Standard Translation Use Cases" description="While the use cases for our standard translation services are endless, there are some common use cases that we see daily." />
      </Suspense>

      <SupportSection windowSize={windowSize} />

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
      <Footer windowSize={windowSize} light={true}  />
    </div>  

  </div>
  
  );
}

export default UseCasesPage;